import styles from './SettingPage.module.scss'
import React from 'react'
import Header from '../../components/Header/Header'
import ScrollToTop from '../../components/Hooks/ScrollToTop'
import { useNavigate } from 'react-router-dom'
import { FaAngleLeft } from "react-icons/fa6";
import Setting from './Setting'

function SettingPage() {
    const navigate = useNavigate()

    return (
        <div className="App">
            <div className="MainContainer">
                <ScrollToTop />
                <Header />
                <div className={`${styles.Container} ${styles.Setting}`}>
                    <div className={styles.BackButton}>
                        <button onClick={() => { navigate('/Home') }}>
                            <FaAngleLeft />
                        </button>
                    </div>
                    <Setting />
                </div>
            </div>
        </div>
    )
}

export default SettingPage


